import React from 'react'
import styled from 'styled-components'

export const ScrollView = ({ children, ...rest }: ScrollViewProps) => {
  return <Container {...rest}>{children}</Container>
}

const Container = styled.div<ScrollViewProps>`
  padding-bottom: 0.5rem;

  ${(props) => {
    if (props.overflowDirection === 'y')
      return `
      overflow-y: auto;
      overflow-x: hidden;
    `

    if (props.overflowDirection === 'x')
      return `
      overflow-y: auto;
      overflow-x: hidden;
    `

    return 'overflow: auto;'
  }}

  ${(props) => {
    if (props.maxHeight) return `max-height: ${props.maxHeight};`
  }}

  &::-webkit-scrollbar {
    width: 0.3rem;
    height: 0.3rem;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0.5rem transparent;
  }

  &::-webkit-scrollbar-thumb {
    transition: background 0.15s ease;
    border-radius: 1.2rem;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.palette.hint};
    }
  }

  background-repeat: no-repeat;
  background-size: 100% 4rem, 100% 4rem, 100% 1.4rem, 100% 1.4rem;

  /* Opera doesn't support this in the shorthand */
  background-attachment: local, local, scroll, scroll;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    ${(props) => {
      if (props.lgOverflowDirection === 'y')
        return `
        overflow-y: auto;
        overflow-x: hidden;
      `

      if (props.lgOverflowDirection === 'x')
        return `
        overflow-y: auto;
        overflow-x: hidden;
      `
    }}
  }
`

export type ScrollViewProps = {
  children: JSX.Element
  maxHeight?: string
  overflowDirection?: 'y' | 'x'
  lgOverflowDirection?: 'y' | 'x'
  className?: string
}
